import { Currency } from '@uniswap/sdk-core'
import { SupportedNetworkId } from 'constants/networks'
import useHttpLocations from 'hooks/environment/useHttpLocations'
import { useMemo } from 'react'
import { WrappedTokenInfo } from 'state/lists/wrappedTokenInfo'

import EthereumLogo from '../../assets/images/ethereum-logo.png'
import MaticLogo from '../../assets/svg/matic-token-icon.svg'

type Network = 'ethereum'

function networkIdToNetworkName(networkId: SupportedNetworkId): Network {
  switch (networkId) {
    case SupportedNetworkId.MAINNET:
      return 'ethereum'
    default:
      return 'ethereum'
  }
}

function getNativeLogoURI(networkId: SupportedNetworkId = SupportedNetworkId.MAINNET): string {
  switch (networkId) {
    case SupportedNetworkId.POLYGON_MUMBAI:
    case SupportedNetworkId.POLYGON:
      return MaticLogo
    default:
      return EthereumLogo
  }
}

function getTokenLogoURI(address: string, networkId: SupportedNetworkId = SupportedNetworkId.MAINNET): string | void {
  const networkName = networkIdToNetworkName(networkId)
  const networksWithUrls = [SupportedNetworkId.MAINNET]
  if (networksWithUrls.includes(networkId)) {
    return `https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/${networkName}/assets/${address}/logo.png`
  }
}

export default function useCurrencyLogoURIs(currency?: Currency | null): string[] {
  const locations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)
  return useMemo(() => {
    const logoURIs = [...locations]
    if (currency) {
      if (currency.isNative) {
        logoURIs.push(getNativeLogoURI(currency.chainId))
      } else if (currency.isToken) {
        const logoURI = getTokenLogoURI(currency.address, currency.chainId)
        if (logoURI) {
          logoURIs.push(logoURI)
        }
      }
    }
    return logoURIs
  }, [currency, locations])
}
